export class PicklistLookupModel {
  HospitalId: string = "";
  PicklistName: string = "";
}
